/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../node_modules/svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "facebook-white-c42f956f--sprite",
  "use": "facebook-white-c42f956f--sprite-usage",
  "viewBox": "0 0 14 25",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 25\" id=\"facebook-white-c42f956f--sprite\"><path d=\"M8.864 24.25V13.416h3.685l.552-4.222H8.863V6.5c0-1.223.345-2.056 2.121-2.056h2.266V.665C12.858.615 11.513.5 9.948.5 6.681.5 4.445 2.467 4.445 6.08v3.114H.75v4.222h3.695V24.25h4.418z\" fill=\"#fff\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
